// @ts-nocheck
import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment, useRef, useState } from 'react';
import CreateClient from './CreateClient';

export const ClientModal = () => {
    const [isOpen, setIsOpen] = useState(false);
    const cancelButtonRef = useRef(null);

    const handleClickOpen = () => {
        setIsOpen(true);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const button1 = (
        <button
            type="submit"
            className="inline-flex h-11 items-center justify-center rounded-xl border border-transparent bg-green-cl px-5 text-sm font-bold text-white shadow-sm transition hover:bg-green-eupago hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-green-cl focus:ring-offset-2"
        >
            Associar
        </button>
    );

    const button2 = (
        <button
            ref={cancelButtonRef}
            type="button"
            onClick={handleClose}
            className="inline-flex h-11 items-center justify-center rounded-xl border border-gray-300 bg-white px-5 text-sm font-bold text-gray-700 shadow-sm transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-green-cl focus:ring-offset-2"
        >
            Cancelar
        </button>
    );

    return (
        <>
            <button
                type="button"
                onClick={handleClickOpen}
                className="inline-flex h-11 min-w-[130px] items-center justify-center whitespace-nowrap rounded-xl border border-transparent bg-green-cl px-5 text-sm font-bold text-white shadow-sm transition hover:bg-green-eupago focus:outline-none focus:ring-2 focus:ring-green-cl focus:ring-offset-2"
            >
                Novo Cliente
            </button>

            <Transition.Root show={isOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-50"
                    initialFocus={cancelButtonRef}
                    onClose={handleClose}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500/75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-50 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative w-full max-w-3xl rounded-2xl bg-white px-4 py-5 text-left shadow-xl sm:my-8 sm:p-6">
                                    <div className="rounded-lg bg-white">
                                        <CreateClient button1={button1} button2={button2} />
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    );
};

export default ClientModal;